<template>
    <CqModal
        :showModal="show"
        :heading="heading"
        :preventClosing="isSaving"
        @closeModal="closeModal"
    >
        <CustomDateSelect
            v-if="rosterRankSet"
            label="Begindatum"
            :min="minDate"
            required
            v-model="rosterRankSet.beginDate"
        />
        <CqButtonBar>
            <CqButton :disabled="isSaving" @click="closeModal" label="Annuleren" />
            <CqButton :disabled="isSaving" primary @click="save" label="Opslaan" icon="save" />
        </CqButtonBar>
    </CqModal>
</template>

<script lang="ts">
    import {CqButton, CqButtonBar, CqModal} from '@cquential/ui';
    import {Prop, Component, Vue} from 'vue-facing-decorator';
    import CustomDateSelect from '@/components/Branding/CustomDateSelect.vue';
    import {RosterRankSet} from '@cquential/api';

    @Component({
        components: {
            CqButton,
            CqButtonBar,
            CqModal,
            CustomDateSelect,
        },
        emits: ['closeModal', 'saveRosterRankSet'],
    })
    export default class RosterRankSetEditModal extends Vue {
        @Prop() public rosterRankSet?: RosterRankSet | null;
        @Prop({type: Date}) public minDate?: Date;
        @Prop({type: Boolean}) public isSaving!: boolean;

        public get show(): boolean {
            return this.rosterRankSet != null;
        }

        public get heading(): string {
            return this.rosterRankSet?.id ? 'Medewerkervolgorde bewerken' : 'Voeg een medewerkervolgorde toe';
        }

        public save(): void {
            this.$emit('saveRosterRankSet', this.rosterRankSet);
        }

        public closeModal(): void {
            this.$emit('closeModal');
        }
    }
</script>
